package com.netguru.multiplatform.charts

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.geometry.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.platform.*
import androidx.compose.ui.unit.*

private val TOUCH_OFFSET = 20.dp
private val OVERLAY_WIDTH = 200.dp

@Composable
internal fun OverlayInformation(
    positionX: Float,
    containerSize: Size,
    surfaceColor: Color,
    touchOffset: Dp = TOUCH_OFFSET,
    overlayWidth: Dp = OVERLAY_WIDTH,
    content: @Composable () -> Unit,
) {
    if (positionX < 0) return
    BoxWithConstraints(
        modifier = Modifier
            .offset(
                x = with(LocalDensity.current) {
                    positionX.toDp() +
                        // change offset based on cursor position to avoid out of screen drawing on the right
                        if (positionX.toDp() > (containerSize.width / 2).toDp()) {
                            -OVERLAY_WIDTH - TOUCH_OFFSET
                        } else {
                            TOUCH_OFFSET
                        }
                },
                y = touchOffset
            )
            .width(OVERLAY_WIDTH)
            .alpha(0.9f)
            .clip(RoundedCornerShape(10.dp))
            .background(surfaceColor)
            .padding(8.dp)
    ) {
        content()
    }
}
